import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function ChapterWisePYQMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="chapterwisepyq" />

    </>
  );
}

export default ChapterWisePYQMathTopics;